import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@fgb/core';
import { ErrorStateService } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { OwlOptions, ResponsiveSettings } from 'ngx-owl-carousel-o';
import { OwlCarouselSettings } from 'src/app/shared/utilities/owl-carousel-settings';

@Component({
  selector: 'fgb-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit {
  screenType = ScreenType;
  customOptions(responsive: ResponsiveSettings): OwlOptions {
    return {
      margin: 22,
      autoHeight: true,
      autoWidth: true,
      pullDrag: true,
      autoplay: false,
      autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
      autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
      navSpeed: 700,
      nav: false,
      dots: true,
      responsive,
    }
  };
  rewardsOptions: OwlOptions = this.customOptions({
    0: { items: 2 },
    900: { items: 3 },
  });
  challengesOptions: OwlOptions = this.customOptions({
    0: { items: 1 },
    900: { items: 3 },
  });
  rewardsItems = [
    { image: 'assets/images/login-registration/hoodie.jpg', title: 'Rewards 1' },
    { image: 'assets/images/login-registration/skirt.jpg', title: 'Rewards 2' },
    { image: 'assets/images/login-registration/hambeger.jpg', title: 'Rewards 3' },
    { image: 'assets/images/login-registration/dinner.jpg', title: 'Rewards 4' },
    { image: 'assets/images/login-registration/special-kit.jpg', title: 'Rewards 5' },
  ]
  constructor(private router: Router, public errorService: ErrorStateService, private authService: AuthService) {
    if (this.authService.hasCurrentRefreshToken()) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() { }
}
